module.exports = __webpack_public_path__ + "img/arrow_w.f71f2580.svg";